module.exports = __webpack_public_path__ + "img/2.f21af0df.png";